import React, { useState, useEffect } from 'react'

//Routing
import { NavLink, Link } from 'react-router-dom'
//Language
import { useTranslation } from 'react-i18next'
import Translate from '../../i18n/Translate'
//Components
import Burger from '../../components/Burger'
import LanguageSelector from '../../components/LanguageSelector'
import Socials from '../../components/Socials'
import ProfesionalAccess from '../../components/ProfesionalAccess'
//Images
import tower_logo from '../../assets/images/tower_logo.svg'
//SVGs
// import UserSvg from '../../components/svg/UserSvg' //NO BORRAR QUITADO TEMPORALMENTE

//SCSS VARIABLES
import configVariables from '../../assets/sass/variables/config.module.scss'

const Header = ({ language }) => {
    const { t } = useTranslation()

    const { colorSecundario } = configVariables

    const [navState, setNavState] = useState(false)
    const [topHeader, setTopHeader] = useState('')

    useEffect(() => {
        //Solo aplicaremos el bloqueo de Scroll cuando se esta en la parte superior de la pagina
        // donde el header es visible en su modo original
        let scrollYoffset = window.pageYOffset

        if (scrollYoffset < 150) {
            if (navState) {
                document.body.style.overflowY = 'hidden'
                document.body.style.maxHeight = '100vh'
            } else {
                document.body.style.overflowY = ''
                document.body.style.maxHeight = ''
            }
        }
    }, [navState])

    useEffect(() => {
        //Setea distintas clases al top header para estar normal, desaparecer o estar con fondo con opacidad y menos alto.
        const scrollListener = () => {
            let scrollYoffset = window.pageYOffset

            if (scrollYoffset < 150) {
                setTopHeader('')
            } else if (scrollYoffset >= 150 && scrollYoffset < 1100) {
                setTopHeader('fade')
                setNavState(false)
            } else if (scrollYoffset >= 1100) {
                setTopHeader('top-alternative')
            }
        }
        document.addEventListener('scroll', scrollListener)

        return () => {
            document.removeEventListener('scroll', scrollListener)
        }
    }, [])

    return (
        <header className={`header_incoming ${topHeader}`}>
            <div className={`header_incoming__top ${navState ? 'menu-open' : 'menu-closed'} ${topHeader}`}>
                <div className={`logo ${navState ? 'hide' : ''}`}>
                    <Link to={`/${language}${t('routes.home')}`}>
                        <img src={tower_logo} alt="tower-travel logo" />
                    </Link>
                </div>

                <div className="right-content">
                    <div className="profesional-access-wrapper">
                        <ProfesionalAccess />
                    </div>

                    {/* QUITADO MOMENTANEAMENTE, NO BORRAR! */}
                    {/* <div className="user-icon">
                        <UserSvg />
                    </div> */}

                    <div className="burger-wrapper" onClick={() => setNavState(!navState)}>
                        <h4>{navState ? `${t('header.close-menu')}` : 'MENU'}</h4>
                        <Burger state={navState} setter={setNavState} />
                    </div>
                </div>
            </div>

            {/* TODO = aria-hidden true cuando no esta abierto para que no accedan el screen reader 
                Aun no funciona bien, habra que aplicar a cada uno de los links accesibles dentro del menu?
            */}
            {/* Contenido desplegable del menu */}
            <div
                className={`header_incoming__options ${navState ? 'open' : ''}`}
                aria-hidden={navState ? 'false' : 'true'}
            >
                <nav className="navigation">
                    <ul className="links-list">
                        <li>
                            <NavLink to={`/${language}${t('routes.home')}`} exact onClick={() => setNavState(false)}>
                                <Translate langkey="routes.home-text" />
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to={`/${language}${t('routes.about')}`} onClick={() => setNavState(false)}>
                                <Translate langkey="routes.about-text" />
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to={`/${language}${t('routes.itineraries')}`} onClick={() => setNavState(false)}>
                                <Translate langkey="routes.itineraries-text" />
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to={`/${language}${t('routes.mice')}`} onClick={() => setNavState(false)}>
                                <Translate langkey="routes.mice-text" />
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to={`/${language}${t('routes.manuals_tourbooks')}`}
                                onClick={() => setNavState(false)}
                            >
                                <Translate langkey="routes.manuals_tourbooks-text" />
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to={`/${language}${t('routes.contact')}`} onClick={() => setNavState(false)}>
                                <Translate langkey="routes.contact-text" />
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to={`/${language}${t('routes.faqs')}`} onClick={() => setNavState(false)}>
                                <Translate langkey="routes.faqs-text" />
                            </NavLink>
                        </li>
                    </ul>
                </nav>
                <div className="profesional-access-wrapper-mobile">
                    <ProfesionalAccess />
                </div>
                <div className="socials-wrapper">
                    <Socials fill={colorSecundario} background="transparent" />
                </div>

                <div className="langs-wrapper">
                    <LanguageSelector />
                </div>
            </div>
        </header>
    )
}

export default Header
